import React from "react"
import {Info} from "react-feather"
import FlexBox from "@/components/layout/FlexBox"
import {useTheme} from "@/hooks/useTheme"

const getStyles = (theme) => ({
  container: {
    marginTop: 15,
    padding: 10,
    borderRadius: 6,
    backgroundColor: `${theme.brand.primary}10`,
    border: `2px solid ${theme.brand.primary}`,
    width: "100%",
    maxWidth: "100%"
  },
  iconContainer: {
    marginRight: 8,
    marginTop: 1,
    opacity: 0.8
  },
  message: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.h2?.color || 'rgba(0, 0, 0, 0.7)',
    lineHeight: 1.4,
    flex: 1
  }
})

export const Hint = ({
                       message,
                       icon,
                       style = {},
                       showIcon = true,
                       useAccentColor = true
                     }) => {
  const theme = useTheme()

  const defaultIcon = <Info
    size={16}
    strokeWidth={1.5}
    color={useAccentColor ? theme.brand.primary : undefined}
  />

  const styles = getStyles(theme)

  if (!message) return null

  return (
    <FlexBox style={{...styles.container, ...style}} row>
      {showIcon && (
        <FlexBox style={styles.iconContainer}>
          {icon || defaultIcon}
        </FlexBox>
      )}
      <FlexBox style={styles.message}>
        {message}
      </FlexBox>
    </FlexBox>
  )
}